// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"60c46a57","498":"b8d6910d","703":"098a55ee","787":"b068cac7"}[chunkId] + ".chunk.js";
};